import { useMemo } from "react";
import { useStore } from "@/stores/useStore";
import { useTickerStore } from "@/stores/useTickerStore";
import { useLayouts } from "@/hooks/useLayouts";
import {
  buildContainerMetricsRows,
  ContainerMetricsRow,
} from "@/lib/containerMetricsMath";

export const useContainerMetricsTable = (
  layoutName: string | undefined
): ContainerMetricsRow[] => {
  const shop = useStore((s) => s.shop);
  const metrics = useStore((s) => s.timeInContainerMetrics);
  const { layouts } = useLayouts();
  const { ticker } = useTickerStore();

  return useMemo(() => {
    // ticker keeps "today" accruing while the page is open, matching the
    // board footer's live behavior
    void ticker;
    if (!shop || !layoutName) return [];
    const layout = layouts.find(
      (candidate) => Object.keys(candidate)[0] === layoutName
    );
    const layoutEntries = layout?.[layoutName];
    if (!layoutEntries) return [];
    return buildContainerMetricsRows({
      layoutEntries,
      containers: shop.containers,
      metrics,
      workingHours: shop.shopConfig?.workingHours,
    });
  }, [shop, metrics, layouts, layoutName, ticker]);
};
